module.exports = __webpack_public_path__ + "img/QR.39f04a2c.png";